import React from 'react';
import { MousePointer, Layout, Wand2, Users } from 'lucide-react';

const EasyToUsePage = () => {
  return (
    <div className="pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Easy to Use Platform
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            An intuitive interface that makes email marketing accessible to everyone, from beginners to experts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <Layout className="h-12 w-12 text-blue-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Intuitive Dashboard</h3>
            <p className="text-gray-600">
              Everything you need at your fingertips with our clean, organized dashboard design.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <Wand2 className="h-12 w-12 text-purple-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Drag-and-Drop Editor</h3>
            <p className="text-gray-600">
              Create beautiful emails in minutes with our simple drag-and-drop interface.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <MousePointer className="h-12 w-12 text-green-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">One-Click Actions</h3>
            <p className="text-gray-600">
              Streamlined workflows that let you accomplish complex tasks with a single click.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <Users className="h-12 w-12 text-amber-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Team Collaboration</h3>
            <p className="text-gray-600">
              Work together seamlessly with role-based access and shared templates.
            </p>
          </div>
        </div>

        <div className="bg-blue-50 rounded-2xl p-8 md:p-12 mb-16">
          <h2 className="text-3xl font-bold mb-8">Getting Started is Simple</h2>
          <div className="space-y-8">
            <div className="flex items-start">
              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-lg font-semibold">
                1
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Sign Up</h4>
                <p className="text-gray-600">
                  Create your account in seconds with just your email address.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-lg font-semibold">
                2
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Import Contacts</h4>
                <p className="text-gray-600">
                  Upload your contact list or integrate with your existing tools.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-lg font-semibold">
                3
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Create Your First Campaign</h4>
                <p className="text-gray-600">
                  Use our templates and AI suggestions to craft your first email.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-lg font-semibold">
                4
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Send and Track</h4>
                <p className="text-gray-600">
                  Launch your campaign and monitor results in real-time.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">5 min</div>
              <p className="text-gray-600">Average setup time</p>
            </div>
            
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">98%</div>
              <p className="text-gray-600">User satisfaction rate</p>
            </div>
            
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">24/7</div>
              <p className="text-gray-600">Support available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EasyToUsePage;